import React, {useCallback, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {FirmwareGetSchema} from '../../../../api/DBSchema/Firmware';
import SMCTable from '../../../../components/core/SMCTable/SMCTable';
import SMCButton from '../../../../components/Simple/SMCButton';
import SetServiceDomainModal from '../../../PopupPages/SetServiceDomainModal';
import {useBoolean} from '../../../../utils/hooks';

const pageSchema = FirmwareGetSchema.pages.serviceDomains;
const pageId = pageSchema.pageId;

function FirmwareServiceDomains({
    firmwareObject,
    setFirmwareData
}) {
    const { t } = useTranslation();

    const pageData = firmwareObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setFirmwareData([pageId, paramName], value);
    }, [setFirmwareData]);

    const serviceDomainList = pageData[pageSchema.serviceDomainList];
    const initialServiceDomainList = useRef(serviceDomainList);
    
    const [isSetServiceDomainModalOpen, openSetServiceDomainModal, closeSetServiceDomainModal] = useBoolean(false);

    return (
        <EditorLayout>
            <SMCTable
                columns={[
                    { id: 'name', header: t('SMP.NAME'), width: 200, Cell: ({object}) => <span>{object}</span> }
                ]}
                content={serviceDomainList}
                hasCheckboxColumn={false}
            />
            <SMCButton style={{ marginTop: '10px', marginLeft: '0px' }} onClick={openSetServiceDomainModal}>{t('SMC_GEN_EDIT')}</SMCButton>
            {/* Popup windows */}
            <SetServiceDomainModal
                isOpen={isSetServiceDomainModalOpen}
                onRequestClose={closeSetServiceDomainModal}
                defaultSelected={serviceDomainList}
                onSuccess={serviceDomainList => {
                    setPageValue(pageSchema.initialServiceDomainList, initialServiceDomainList.current);
                    setPageValue(pageSchema.serviceDomainList, serviceDomainList);
                    closeSetServiceDomainModal();
                }}
            />
        </EditorLayout>
    )
}

export default FirmwareServiceDomains;